import { borderTypes } from "@sonic/Overrides/Components/FormField/formStyles";
import { css } from "styled-components";

borderTypes.focus = {
    ...borderTypes.focus,
    css: css`
        border: none;
    `,
};
borderTypes.error = {
    ...borderTypes.error,
    css: css`
        border: none;
        border-bottom: 1px solid #e30613;
    `,
};
borderTypes.inactive = { ...borderTypes.inactive };
